import jwt from 'jsonwebtoken';
import services from '../utils/services';
import { CONFIG } from '../config/constant';

const JWT_SECRET = CONFIG.jwt.secret;
const JWT_EXPIRES_TIME = CONFIG.jwt.timeout;

const delay = (timeout) => {
  return new Promise((res) => setTimeout(res, timeout));
};

const users = [
  {
    id: '',
    document: '',
    password: ''
  }
];

services.onPost('/api/account/login').reply(async (config) => {
  try {
    await delay(500);

    const { document, password } = JSON.parse(config.data);
    const user = users.find((_user) => _user.document === document);

    if (!user) {
      return [400, { message: 'Verify Your Email & Password' }];
    }

    if (user.password !== password) {
      return [400, { message: 'Invalid Password' }];
    }

    const access_token = jwt.sign({ userId: user.id }, JWT_SECRET, { expiresIn: JWT_EXPIRES_TIME });

    return [
      200,
      {
        access_token,
        user: {
          id: user.id,
          document: user.document
        }
      }
    ];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Server Error' }];
  }
});

services.onGet('/api/account/me').reply((config) => {
  try {
    const { Authorization } = config.headers;

    if (!Authorization) {
      return [401, { message: 'Token Missing' }];
    }

    const access_token = Authorization.split(' ')[1];
    const { userId } = jwt.verify(access_token, JWT_SECRET);
    const user = users.find((_user) => _user.id === userId);

    if (!user) {
      return [401, { message: 'Invalid Token' }];
    }

    return [
      200,
      {
        user: {
          id: user.id,
          document: user.document
        }
      }
    ];
  } catch (err) {
    return [500, { message: 'Server Error' }];
  }
});
